// extracted by mini-css-extract-plugin
export var servicesClients = "services-clients-module--servicesClients--5pcpT";
export var row = "services-clients-module--row--3PVzM";
export var column = "services-clients-module--column--2ifp0";
export var title = "services-clients-module--title--3Njop";
export var link = "services-clients-module--link--2gKBv";